import { IUserRef } from "./userData.model";

export enum ServiceTicketType {
  monitoring = "monitoring",
  inverterFault = "inverterFault",
}

export interface IAddress {
  addressLine1?: string | undefined;
  state: string;
  district: string;
  taluka?: string;
  pincode: string;
}

export interface IServicePartner {
  _id?: string;
  name: string;
  mobileNumber: string;
  address: IAddress;
  companyName?: string;
}

export interface IServiceTicket {
  _id?: string;
  ticketNumber?: number;
  ticketType: ServiceTicketType;
  status?: string;
  epcName: string;
  epcMobileNumber: string;
  epcPincode: string;
  siteAddress: string;
  complainNote?: string;
  customerName: string;
  customerMobileNumber: string;
  customerAddress: IAddress;
  serialNumber: string;
  loggerSerialNo?: string;
  servicePartner?: IServicePartner;
  assignee?: IUserRef;
  inverterModel?: string;
  errorCode?: string;
  createdAt?: Date;
  resolutionType?: "replaced" | "repaired";
  resolvedAt?: Date;
}

export interface IServiceStatus {
  _id?: string;
  status: string;
}
